import axios from '../api' // 倒入 api

// 获取用车报表
const getOrderCauseStatistic = (params) => {
  return axios({
    url: '/api/report/ordercause/statistic',
    method: 'GET',
    params,
  })
}

//获取车辆统计信息
const getHomeCarStatistic = () => {
  return axios({
    url: '/api/report/car/statistic',
    method: 'GET',
  })
}

//获取司机统计信息
const getHomeDriverStatistic = () => {
  return axios({
    url: '/api/report/driver/statistic',
    method: 'GET',
  })
}

//获取部门用车分析
const getHomeCarorderCount = (params) => {
  return axios({
    url: '/api/report/carorder/count/org',
    method: 'GET',
    params,
  })
}

//获取车辆出车数排名
const getHomeCarTaskRank = (params) => {
  return axios({
    url: '/api/report/car/task/top',
    method: 'GET',
    params,
  })
}

//获取车辆费用统计
const getHomeFee = (params) => {
  return axios({
    url: '/api/report/fee',
    method: 'GET',
    params,
  })
}

//获取车辆用车分布
const getHomeOrderCount = (params) => {
  return axios({
    url: '/api/report/carorder/count',
    method: 'GET',
    params,
  })
}

//获取司机出车排名
const getHomeDriverRank = (params) => {
  return axios({
    url: '/api/report/driver/task/top',
    method: 'GET',
    params,
  })
}

const noticeRemind = (data) => {
  return axios({
    url: '/api/notice/remind',
    method: 'POST',
    data,
  })
}

const noticeDelete = (data) => {
  return axios({
    url: '/api/notice/delete',
    method: 'delete',
    data,
  })
}

const noticeRead = (data) => {
  return axios({
    url: '/api/notice/read',
    method: 'put',
    data,
  })
}

const noticeReadAll = (data) => {
  return axios({
    url: '/api/notice/read/all',
    method: 'put',
    data,
  })
}

// 默认全部倒出
// 根绝需要进行
export default {
  getOrderCauseStatistic,
  getHomeCarorderCount,
  getHomeCarStatistic,
  getHomeDriverStatistic,
  getHomeCarTaskRank,
  getHomeFee,
  getHomeOrderCount,
  getHomeDriverRank,
  noticeRemind,
  noticeDelete,
  noticeRead,
  noticeReadAll,
}
